// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__vLcJb","text":"InfoBox_text__hLTU+","icon":"InfoBox_icon__oMY3M"};